import { Component, OnInit, Input, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { GlobalNamespace as _GlobalNS } from '../../../../environments/environment';
import { PropertySearchService } from '../property-search.service';

@Component({
  selector: 'app-property-search-results',
  templateUrl: './property-search-results.component.html',
  styleUrls: ['./property-search-results.component.scss']
})
export class PropertySearchResultsComponent implements OnInit {

  @Input() pageChange: any;
  @Input() rows: number;
  @Input() paginator: boolean;
  @Input() lazy: boolean = false;
  @Input('value') properties: object[] = [];
  @Input() searchCriteria: any = {};

  propertyTaskRoute = (<any>_GlobalNS).routes.property.viewTasks;
  excelUri = (<any>_GlobalNS).api.property.buildExcel;
  loading: boolean = false;
  pagination: object = {};
  totalRecords = 0;
  routes = {};
  
  constructor(private changeDetectorRef: ChangeDetectorRef, private _searchSvc: PropertySearchService) { }

  ngOnInit() {
    (<any>this).routes.viewTasks = this.propertyTaskRoute;
  }

  loadData(event) {
    this.loading = true;
    this.changeDetectorRef.detectChanges();
    this.pageChange(event);
  }
  exportExcel():string {
    let uri = this.excelUri;
    for (const key in this.searchCriteria) {
      if (key && this.searchCriteria[key]) {
        if (this.searchCriteria[key] !== null && this.searchCriteria[key].length > 0) {
          uri = uri + '&' + key + '=' + this.searchCriteria[key];
        }
      }
    }
   return uri;
  }
}